module.exports = __webpack_public_path__ + "img/ranking-bg-2.5afc0ad.png";